'use strict';

export default {
  name: 'Scroll',
  inserted(el, binding) {
    const f = (evt) => {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
};



// WEBPACK FOOTER //
// ./src/directives/Scroll.js